'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDOM = exports.findByTestAttr = undefined;

var _reactTestRenderer = require('react-test-renderer');

var _reactTestRenderer2 = _interopRequireDefault(_reactTestRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Notes:
 * - Stateless components have no instances: https://github.com/facebook/react/issues/15749
*/

/**
 * Return node(s) with the given data-test attribute.
 * @param {ShallowWrapper} wrapper - Enzyme shallow wrapper.
 * @param {string} val - Value of data-test attribute for search.
 * @returns {ShallowWrapper}
 */
var findByTestAttr = exports.findByTestAttr = function findByTestAttr(wrapper, val) {
  return wrapper.find('[data-test="' + val + '"]');
};

/**
 * Return object of DOM.
 * @param {node} - node from styled components.
 * @returns {object} - Information dom from styled components.
 */
var renderDOM = exports.renderDOM = function renderDOM(render) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';

  switch (type) {
    case 'json':
      return _reactTestRenderer2.default.create(render).toJSON();
    case 'instance':
      return _reactTestRenderer2.default.create(render).root;
    default:
      return _reactTestRenderer2.default.create(render);
  }
};

exports.default = findByTestAttr;